import { createContext as createReactContext, useContext } from "react";

import type { Key } from "react-stately";

export type SidebarNavSize = "sm" | "lg";

export interface SidebarNavContextValue {
  selectedKeys: Set<Key>;
  expandedKeys: Set<Key>;
  onSelect?: (key: Key) => void;
  onToggleExpand?: (key: Key) => void;
  theme: "light" | "dark";
  size: SidebarNavSize;
  isCollapsed: boolean;
}

const SidebarNavContext = createReactContext<SidebarNavContextValue | null>(null);

export const SidebarNavProvider = SidebarNavContext.Provider;

export function useSidebarNavContext(): SidebarNavContextValue {
  const context = useContext(SidebarNavContext);
  if (!context) {
    throw new Error("useSidebarNavContext must be used within a SidebarNavProvider");
  }
  return context;
}
